import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Yeast Infection treatment type.
 */
export const YeastInfectionTreatment = new TreatmentType({
  id: '2',
  name: ConsultationTreatmentTypes.YeastInfection,
  genderSettings: new TreatmentGenderSettings({
    disallowed: [Gender.Male],
    errorMessage: 'Yeast Infection and UTI treatments are only available for female patients.',
  }),
});
